import moment from 'moment';
import React from 'react';
import voca from 'voca';

export const HTMLFileTable = ({ customHtmlCdns }) => {
  if (!customHtmlCdns || customHtmlCdns.length === 0) return '';
  return (
    <table className="table table-bordered table-word-break">
      <thead>
        <tr>
          <th>#</th>
          <th>HTML File Url</th>
        </tr>
      </thead>
      <tbody>
        {customHtmlCdns.map((file, index) => (
          <tr key={file.uuid}>
            <td>{index + 1}</td>
            <td title={file.urlOrTag}>
              <p title={file.urlOrTag}>
                {voca.first(file.urlOrTag, 40)}.....
                {voca.last(file.urlOrTag, 40)}
              </p>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
